import { render } from "./PartenairesComponent.vue?vue&type=template&id=2a45f240"
import script from "./PartenairesComponent.vue?vue&type=script&lang=js"
export * from "./PartenairesComponent.vue?vue&type=script&lang=js"

import "./PartenairesComponent.vue?vue&type=style&index=0&id=2a45f240&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__